import { useGetContractPackages } from '../../../hooks/event-store-hooks';
import { PaginationProps, useClientPagination } from '../../../components';
import { DeployContractPackageResult } from '@block-explorer/entities';
import React, { useEffect } from 'react';
import { filterSystemContracts } from '../utils';

type RandomReshuffledFeaturedContracts = {
  data: DeployContractPackageResult[] | null;
  loading: boolean;
  error: string | null;
  paginationProps: PaginationProps;
};

export const useGetRandomReshuffledFeaturedContracts =
  (): RandomReshuffledFeaturedContracts => {
    const {
      data: featuredContracts,
      loading,
      error,
    } = useGetContractPackages({
      includes:
        'account_info,centralized_account_info,activity_num(30),cspr_name',
      is_featured: true,
      page_size: 25,
    });

    const reshuffledMemo = React.useMemo(
      () =>
        (featuredContracts || [])
          .filter((contract) => contract.is_featured)
          .sort(() => Math.random() - 0.5),
      [featuredContracts]
    );

    const filteredSystemContracts = filterSystemContracts(reshuffledMemo);

    const {
      data: paginatedFeaturedContracts,
      paginationProps,
      resetState,
    } = useClientPagination({
      paginationStateKey: 'homeFeatureContracts',
      arr: filteredSystemContracts || null,
      requestParams: {
        defaultPageSize: 1,
      },
    });

    useEffect(() => {
      resetState?.();
    }, []);

    return {
      data: paginatedFeaturedContracts,
      loading: loading,
      error: error,
      paginationProps: paginationProps,
    };
  };
